import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Custom hook for responsive design breakpoints
 * Provides convenient boolean values for different screen sizes
 */
export const useResponsive = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // < 900px
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // 900px - 1200px
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // >= 1200px

  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isMediumMobile = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600px - 900px
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl')); // >= 1536px

  const orientation = useMediaQuery('(orientation: portrait)') ? 'portrait' : 'landscape';
  const isTouch = useMediaQuery('(pointer: coarse)'); // Touch device detection

  return {
    // Main breakpoints
    isMobile,
    isTablet,
    isDesktop,

    // Specific sizes
    isSmallMobile,
    isMediumMobile,
    isLargeScreen,

    // Device characteristics
    orientation,
    isTouch,

    // Utility functions
    getCurrentBreakpoint: () => {
      if (isSmallMobile) return 'xs';
      if (isMediumMobile) return 'sm';
      if (isMobile) return 'md';
      if (isTablet) return 'lg';
      return 'xl';
    },

    // Touch-friendly sizes
    getTouchFriendlySize: (baseSize: number) => isTouch ? Math.max(baseSize, 44) : baseSize,

    // Responsive padding/margin
    getSpacing: (mobile: number, desktop: number) => isMobile ? mobile : desktop,
  };
};

export default useResponsive;
